// /login — unauthenticated route hosting <LoginPage>.
// -----------------------------------------------------------------
// Per dispatch m3-2-auth-rules-listener.md § 6.11.
//
// If an authenticated admin lands here (e.g. by typing /login in
// the URL bar after they're already signed in), redirect them to
// /hello rather than showing the login card again. Non-admin
// authenticated users still see the login page so they can sign
// out and try a different account.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { LoginPage } from '@/auth/LoginPage';
import { auth } from '@/lib/firebase';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    // No async wait on auth-state hydration here — if the SDK
    // already has a hydrated user (returning visitor), we redirect.
    // First-load users (auth.currentUser === null until the listener
    // fires) see the login form, then AuthContext flips and the
    // app re-renders into the protected tree.
    const user = auth.currentUser;
    if (user) {
      // We don't read claims here (would require an awaited
      // getIdTokenResult); ProtectedRoute downstream re-routes to
      // /no-access if the user lacks `admin: true`.
      throw redirect({ to: '/hello' });
    }
  },
  component: LoginPage,
});
